import React from "react";
import UserServers from "@/components/discord/UserServers";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

function Fact({ label, value, testId }) {
  return (
    <div>
      <div className="label-eyebrow mb-0.5">{label}</div>
      <div className="text-sm break-all" data-testid={testId}>{value || "—"}</div>
    </div>
  );
}

// Expanded "profile" row in Dashboard → Discord Users: account facts + their Discord servers.
export default function DiscordUserProfile({ u, ctx, onBlacklisted }) {
  return (
    <div className="p-5 bg-[var(--ff-surface)]/60 border-t border-[var(--ff-border)] space-y-5" data-testid={`discord-user-profile-${u.id}`}>
      <div className="flex items-center gap-4">
        {u.discord_avatar
          ? <img src={u.discord_avatar} alt="" className="w-12 h-12 rounded-full" />
          : <div className="w-12 h-12 rounded-full bg-[var(--ff-red)] text-white flex items-center justify-center">?</div>}
        <div>
          <div className="font-display text-2xl">{u.discord_username || u.name || "—"}</div>
          <div className="font-mono-ui text-[0.65rem] text-[var(--ff-text-dim)]">Discord ID {u.discord_id}</div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Fact label="Email" value={u.email} testId={`discord-user-profile-email-${u.id}`} />
        <Fact label="Joined" value={fmt(u.created_at)} />
        <Fact label="Last login" value={fmt(u.last_login_at)} />
        <Fact label="Status" value={u.is_banned ? `Banned — ${u.ban_reason || "no reason"}` : "Active"} testId={`discord-user-profile-status-${u.id}`} />
      </div>
      <UserServers guilds={u.discord_guilds || []} fullGuilds={u.discord_guilds_full || []} fullAt={u.discord_guilds_full_at} blacklistIds={ctx.blacklistIds} homeGuildId={ctx.homeGuildId} defaultGrace={ctx.defaultGrace}
        ownerName={u.discord_username} onBlacklisted={onBlacklisted} syncedAt={u.last_guild_sync_at} syncSource={u.last_guild_sync_source}
        testPrefix={`profile-${u.id}`} />
    </div>
  );
}
